export default __webpack_public_path__ + "static/media/Bookings.f08e2e95.svg";